import Animation from './animation'
import { EPSILON } from 'chart-constants'

/*
 * This animation is used when a reference band serie is removed
 *
 * It uses the default animation, but clears the fills and totalThresholds
 */
class ExitingAnimation extends Animation {

  match (serie) {
    return this.seriesChanged && // Series changed
           this.exitingSeries.selection().data().indexOf(serie) !== -1
  }

  configure (axis, serie) {
    super.configure(axis, serie)
    this.fills = [] // clear them
    this.totalThresholds = 0

    if (!this.yScale) {
      // yscale is no longer defined for this axis, use the old one
      this.yScale = this.previous.scalers.y[axis]
    }

    return this
  }

}

export default ExitingAnimation
